import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import supabase from "../config/supabaseClient";

const statTypes = [
  "finish",
  "finish(adversary)",
  "goal opportunities",
  "goal opportunities(adversary)",
  "offensive corners",
  "offensive corners(adversary)",
  "committed fouls",
  "committed fouls(adversary)",
  "offsides",
  "offsides(adversary)"
];

const GameStatsPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const gameId = searchParams.get('gameId');

  const [stats, setStats] = useState([]);
  const [fetchError, setFetchError] = useState(null);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        // 👇 Override the fetch used by Supabase to disable cache
        const { data, error } = await supabase
          .from('stat')
          .select('*')
          .eq('game_id', gameId)
          .throwOnError()
          .abortSignal(new AbortController().signal, {
            fetch: (url, options) => fetch(url, { ...options, cache: 'no-store' })
          });

        if (error) throw error;

        const initializedStats = statTypes.map(type => {
          const existing = data.find(d => d.type === type);
          return { type, number: existing ? existing.number : 0, id: existing?.id || null };
        });

        setStats(initializedStats);
      } catch (error) {
        setFetchError('Could not fetch stats: ' + (error.message || 'Unknown error'));
      }
    };

    fetchStats();
  }, [gameId]);

  const updateStat = async (stat, newNumber) => {
    try {
      if (stat.id) {
        const { error } = await supabase
          .from('stat')
          .update({ number: newNumber })
          .eq('id', stat.id);
        if (error) throw error;
      } else {
        const { data, error } = await supabase
          .from('stat')
          .insert({ game_id: gameId, type: stat.type, number: newNumber })
          .select()
          .single();
        if (error) throw error;
        stat.id = data.id;
      }

      setStats(prev =>
        prev.map(s => s.type === stat.type ? { ...s, number: newNumber, id: stat.id } : s)
      );
    } catch (error) {
      setFetchError('Error updating stat: ' + (error.message || 'Unknown error'));
    }
  };

  const handleIncrement = (stat) => updateStat(stat, stat.number + 1);
  const handleDecrement = (stat) => {
    if (stat.number > 0) updateStat(stat, stat.number - 1);
  };

  return (
    <div className="page game-stats-page">
      <button onClick={() => navigate(-1)} className="back-button">Back to Game</button>
      <h2>Game Stats</h2>

      {fetchError && <p className="error">{fetchError}</p>}

      <div className="stats-list">
        {stats.map(stat => (
          <div key={stat.type} className="stat-item" style={{ marginBottom: '10px' }}>
            <span style={{ marginRight: '10px', width: '220px', display: 'inline-block' }}>
              {stat.type}
            </span>
            <button onClick={() => handleDecrement(stat)}>-</button>
            <span style={{ margin: '0 10px' }}>{stat.number}</span>
            <button onClick={() => handleIncrement(stat)}>+</button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default GameStatsPage;
